var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { ToggleGroup } from '@snack-uikit/toggles';
import { extractSupportProps } from '@snack-uikit/utils';
export function Accordion(_a) {
    var { children, expanded, onExpandedChange, expandedDefault, selectionMode = 'single', className } = _a, rest = __rest(_a, ["children", "expanded", "onExpandedChange", "expandedDefault", "selectionMode", "className"]);
    return (
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    _jsx(ToggleGroup, { value: expanded, defaultValue: expandedDefault, onChange: onExpandedChange, selectionMode: selectionMode, children: _jsx("div", Object.assign({ className: className }, extractSupportProps(rest), { children: children })) }));
}
